import { NgModule, forwardRef } from '@angular/core';
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { SharedModule } from '../../../common/shared.module';
import { ResourceComponent } from './resource/resource.component';
import { SlideDeckComponent } from './resource/slide-deck/slide-deck.component';
import { PictureResourceComponent } from './resource/picture-resource/picture-resource.component';
import { MediaResourceComponent } from './resource/media-resource/media-resource.component';
import { PDFResourceComponent } from './resource/pdf-resource/pdf-resource.component';
import { HtmlResourceComponent } from './resource/html-resource/html-resource.component';
import { AutoPlayResourceComponent } from './resource/auto-play-resource/auto-play-resource.component';
import { AssociateInteractionComponent, ChoiceInteractionComponent, ExtendedTextInteractionComponent, HotspotComponent, InlineChoiceInteractionComponent,
    InteractionComponent, MatchInteractionComponent, OrderInteractionComponent, SpeakingInteractionComponent, TextEntryInteractionComponent } from './interaction';
import { AutoSkipTimerComponent } from './misc/auto-skip-timer/auto-skip-timer.component';
import { EndOfTestComponent } from './misc/end-of-test/end-of-test.component';
import { IppWritingSampleResponseComponent } from './ipp/ipp-writing-sample-response/ipp-writing-sample-response.component';
import { IppLandingPageComponent } from './ipp/ipp-landing-page/ipp-landing-page.component';
import { IppSpeakingSampleResponseComponent } from './ipp/ipp-speaking-sample-response/ipp-speaking-sample-response.component';
import { IppTranscriptComponent } from './ipp/ipp-transcript/ipp-transcript.component';
import { IppAnswerkeyComponent } from './ipp/ipp-answerkey/ipp-answerkey.component';
import { IppScoringPageComponent } from './ipp/ipp-scoring-page/ipp-scoring-page.component';
import { IppFeedbackPageComponent } from './ipp/ipp-feedback-page/ipp-feedback-page.component';
import { IppEndOfTestComponent } from './ipp/ipp-end-of-test/ipp-end-of-test.component';
import { IppMicrophoneCheckComponent } from './ipp/ipp-microphone-check/ipp-microphone-check.component';
import { IppDownloadResponseComponent} from './ipp/ipp-download-response/ipp-download-response.component';
import { IppVoiceRecorderComponent } from './ipp/ipp-voice-recorder/ipp-voice-recorder.component';

export const DYNAMIC_DIRECTIVES = [
    forwardRef(() => InteractionComponent),
    forwardRef(() => ResourceComponent),
    forwardRef(() => SlideDeckComponent),
    forwardRef(() => PictureResourceComponent),
    forwardRef(() => MediaResourceComponent),
    forwardRef(() => PDFResourceComponent),
    forwardRef(() => HtmlResourceComponent),
    forwardRef(() => AutoPlayResourceComponent),
    forwardRef(() => ChoiceInteractionComponent),
    forwardRef(() => InlineChoiceInteractionComponent),
    forwardRef(() => SpeakingInteractionComponent),
    forwardRef(() => ExtendedTextInteractionComponent),
    forwardRef(() => TextEntryInteractionComponent),
    forwardRef(() => HotspotComponent),
    forwardRef(() => ResourceComponent),
    forwardRef(() => OrderInteractionComponent),
    forwardRef(() => AssociateInteractionComponent),
    forwardRef(() => MatchInteractionComponent),
    forwardRef(() => AutoSkipTimerComponent),
    forwardRef(() => EndOfTestComponent),
    forwardRef(() => IppLandingPageComponent),
    forwardRef(() => IppWritingSampleResponseComponent),
    forwardRef(() => IppSpeakingSampleResponseComponent),
    forwardRef(() => IppTranscriptComponent),
    forwardRef(() => IppAnswerkeyComponent),
    forwardRef(() => IppScoringPageComponent),
    forwardRef(() => IppFeedbackPageComponent),
    forwardRef(() => IppEndOfTestComponent),
    forwardRef(() => IppMicrophoneCheckComponent),
    forwardRef(() => IppDownloadResponseComponent),
    forwardRef(() => IppVoiceRecorderComponent)
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule
    ],
    declarations: [
        DYNAMIC_DIRECTIVES
    ],
    exports: [
        DYNAMIC_DIRECTIVES
    ]
})
export class DynamicComponentModule {
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/dynamic-component-module.ts